export const BRAZE_BANNERS_ID = Object.freeze({
	ACTIVE_BIDS: 'dealer_webapp_kyc_active_bids',
	BID_FOOTER: 'dealer_webapp_kyc_bid_footer',
	SELLER_DETAILS: 'dealer_webapp_kyc_seller_details',
});
